import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// Lodash
import _includes from 'lodash/includes';
import _toLower from 'lodash/toLower';
import _noop from 'lodash/noop';

// Constants
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import { ENTER_KEY_CODE } from '@tekion/tekion-base/constants/keyCode.constants';

// Components
import MenuPortal from '../advancedSelect/components/MenuPortal';
import MenuList from './components/menuList';
var REACT_SELECT_VIRTUALIZATION_COMPONENTS = {
  MenuPortal: MenuPortal,
  MenuList: MenuList
};
var withVirtualized = function withVirtualized(WrappedComponent) {
  var WithVirtualized = /*#__PURE__*/function (_PureComponent) {
    _inherits(WithVirtualized, _PureComponent);
    var _super = _createSuper(WithVirtualized);
    function WithVirtualized() {
      var _this;
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
      _classCallCheck(this, WithVirtualized);
      _this = _super.call(this, props);
      _defineProperty(_assertThisInitialized(_this), "handleOptionSearch", function (searchText, event) {
        var onInputChange = _this.props.onInputChange;
        var action = event.action;
        if (action === 'input-change') {
          _this.setState({
            searchText: searchText
          });
        }
        onInputChange(searchText, event);
      });
      _defineProperty(_assertThisInitialized(_this), "handleOnKeyDown", function (event) {
        var onInputChange = _this.props.onInputChange;
        if ((event === null || event === void 0 ? void 0 : event.keyCode) === ENTER_KEY_CODE) {
          _this.setState({
            searchText: ''
          });
          onInputChange('', event);
        }
      });
      _defineProperty(_assertThisInitialized(_this), "filterOptions", function (option, searchtext) {
        var filterOption = _this.props.filterOption;
        if (filterOption) {
          return filterOption(option, searchtext);
        }
        return _includes(_toLower(option.label), _toLower(searchtext));
      });
      _this.state = {
        searchText: ''
      };
      var customComponents = props.components;
      _this.components = _objectSpread(_objectSpread({}, customComponents), REACT_SELECT_VIRTUALIZATION_COMPONENTS);
      return _this;
    }
    _createClass(WithVirtualized, [{
      key: "render",
      value: function render() {
        var options = this.props.options;
        var searchText = this.state.searchText;
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, this.props, {
          components: this.components,
          options: options,
          filterOption: this.filterOptions,
          inputValue: searchText,
          onInputChange: this.handleOptionSearch,
          menuPlacement: "auto",
          onKeyDown: this.handleOnKeyDown
        }));
      }
    }]);
    return WithVirtualized;
  }(PureComponent);
  WithVirtualized.propTypes = {
    options: PropTypes.array,
    components: PropTypes.array,
    isSearchable: PropTypes.bool,
    filterOption: PropTypes.func,
    onInputChange: PropTypes.func
  };
  WithVirtualized.defaultProps = {
    options: EMPTY_ARRAY,
    components: REACT_SELECT_VIRTUALIZATION_COMPONENTS,
    isSearchable: true,
    filterOption: undefined,
    onInputChange: _noop
  };
  return WithVirtualized;
};
export default withVirtualized;